import { NgModule } from '@angular/core';
import { SharedModule } from '../../modules/shared.module';
import { RouterModule } from '@angular/router';
import { EguardNavigationComponent } from './navigation.component';
import { EguardNavVerticalItemComponent } from './vertical/nav-item/nav-vertical-item.component';
import { EguardNavVerticalCollapseComponent } from './vertical/nav-collapse/nav-vertical-collapse.component';
import { EguardNavVerticalSubheaderComponent } from './vertical/nav-subheader/nav-vertical-subheader.component';
import { EguardNavHorizontalItemComponent } from './horizontal/nav-item/nav-horizontal-item.component';
import { EguardNavHorizontalCollapseComponent } from './horizontal/nav-collapse/nav-horizontal-collapse.component';

@NgModule({
    imports     : [
        SharedModule,
        RouterModule
    ],
    exports     : [
        EguardNavigationComponent
    ],
    declarations: [
        EguardNavigationComponent,
        EguardNavVerticalSubheaderComponent,
        EguardNavVerticalItemComponent,
        EguardNavVerticalCollapseComponent,
        EguardNavHorizontalItemComponent,
        EguardNavHorizontalCollapseComponent
    ]
})
export class EguardNavigationModule
{
}



// WEBPACK FOOTER //
// ./src/app/core/components/navigation/navigation.module.ts